import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/20.png';
import _imports_2 from '../../../assets/new/32.png';
import _imports_3 from '../../../assets/new/49.png';
import _imports_4 from '../../../assets/new/9.png';
import _imports_5 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-043bacd3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"avatar\" data-v-043bacd3><img src=\"" + _imports_1 + "\" data-v-043bacd3></div><div class=\"list\" data-v-043bacd3><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>姓名</span><span data-v-043bacd3>李佳阳<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>ID</span><span data-v-043bacd3>N4934703<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>等级</span><span data-v-043bacd3>Lv12<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>学校</span><span data-v-043bacd3>吉林省抚松县第七小学<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>班级</span><span data-v-043bacd3>四年级3班<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div><div class=\"item\" data-v-043bacd3><span data-v-043bacd3>性别</span><span data-v-043bacd3>女<img src=\"" + _imports_2 + "\" data-v-043bacd3></span></div></div><div style=\"height:6rem;\" data-v-043bacd3></div>", 3);
const _hoisted_8 = {
  class: "footer"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
export default {
  __name: 'user_copy',
  setup(__props) {
    const pid = getLocalPid();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_4), _createTextVNode(" 个人信息 ")]), _hoisted_5, _createElementVNode("div", _hoisted_8, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_9, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_10, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_11, _createTextVNode(" 个人中心 ")])])]);
    };
  }
};